import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import moment from 'moment';
import _ from 'lodash';
import ReactPaginate from 'react-paginate';

import Spinner from '../../components/generics/Spinner';

import WeightedPrice from '../../components/reports/WeightedPrice';
import ReportHeader from '../../components/generics/ReportHeader';
import Filter from '../../components/generics/Filter';
import NoPermissionMessage from '../../components/generics/NoPermissionMessage';

import {
  fetchWeightedPriceReport,
  fetchWeightedPriceReportSuccess,
  fetchWeightedPriceReportFailure,
  fetchWeightedPriceReportCSV,
  fetchWeightedPriceReportCSVSuccess,
  fetchWeightedPriceReportCSVFailure,
} from "../../store/reports/actions";

import { STARTING_PAGE, DEBOUNCE_SEARCH } from '../../constants/constants';
import { withRouter } from "utils/WithRouter";

export class WeightedPriceContainer extends Component {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);
    this.state = {
      page: 1,
      plant: '',
      lot: '',
    };

    this.changeSearch = _.debounce(() => {
      this.searchRefresh();
      this.updateResults();
    }, DEBOUNCE_SEARCH);
  }

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    const page = params.page ? params.page : STARTING_PAGE;
    const plant = params.plant ? params.plant : this.state.plant;
    const lot = params.lot ? params.lot : this.state.lot;

    // Fetch initial page
    this.setState({ page, plant, lot }, () => {
      this.props.getWeightedPriceReport(page, plant, lot);
      this.props.fetchWeightedPriceReportCSV(plant, lot);
    });
  }

  onPlantChange = (event) => {
    const plant = event.target.value ? event.target.value : "";
    this.setState({ plant }, () => {
      this.changeSearch();
    });
  };

  onLotChange = (event) => {
    const lot = event.target.value ? event.target.value : "";
    this.setState({ lot }, () => {
      this.changeSearch();
    });
  };

  updateResults = () => {
    const { page, plant, lot } = this.state;
    let params = {};
    if (plant) params.plant = plant;
    if (lot) params.lot = lot;
    params.page = page;
    this.props.history.push({ search: queryString.stringify(params) });
  };

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let page = data.selected + 1;
    if (page !== this.state.page) {
      this.setState({ page }, () => {
        this.changeSearch();
      });
    }
  };

  searchRefresh = () => {
    const { page, plant, lot } = this.state;
    this.props.getWeightedPriceReport(page, plant, lot);
    this.props.fetchWeightedPriceReportCSV(plant, lot);
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){
    return (
      <div>
        <div className="card mb-2">
          <ReportHeader title='Weighted Price Report' actionTitle='Export CSV'
                        actionClass='btn btn-primary m-0'
                        headers={['Item', 'Brand', 'Grade', 'Total Weight', 'Weighted Price Avg']}
                        csvData={this.props.weightedPricesCSV.csv}
                        filename={`weighted_price_avg-${moment().format('MMM-DD-YYYY')}.csv`}
                        csvLoading={this.props.weightedPricesCSV.loading}
          />
          <Filter
            searchLabel="Plant"
            searchPlaceholder="Search by plant"
            searchVal={this.state.plant}
            onSearchChange={this.onPlantChange}
            searchLabel2="Lot"
            searchPlaceholder2="Search by lot"
            searchVal2={this.state.lot}
            onSearchChange2={this.onLotChange}
          />
        </div>
        <WeightedPrice weightedPriceList={this.props.weightedPrices.list}/>
        {this.props.weightedPrices.pages > 1 &&
          <ReactPaginate pageCount={this.props.weightedPrices.pages}
                          pageRangeDisplayed={2}
                          marginPagesDisplayed={1}
                          previousLabel="<"
                          nextLabel=">"
                          onPageChange={this.handlePageRequest}
                          initialPage={this.state.page-1}
                          disableInitialCallback={true}
                          containerClassName="pagination"
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          activeClassName="page-item active"
                          previousClassName="paginate_button previous"
                          nextClassName="paginate_button next"
                          disabledClassName="page-item disabled"
                          forcePage={this.state.page-1}/>
        }
        {this.props.weightedPrices.loading ? <Spinner /> : null}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    weightedPrices: state.reports.weightedPrices,
    weightedPricesCSV: state.reports.weightedPricesCSV,
    currentUser: state.auth.currentUser
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getWeightedPriceReport: (page, plant, lot) => {
      dispatch(fetchWeightedPriceReport(page, plant, lot)).payload.then((response) => {
        dispatch(fetchWeightedPriceReportSuccess(response.data));
      }, (error) => {
        dispatch(fetchWeightedPriceReportFailure(error));
      });
    },
    fetchWeightedPriceReportCSV: (plant, lot) => {
      dispatch(fetchWeightedPriceReportCSV(plant, lot)).payload.then((response) => {
        dispatch(fetchWeightedPriceReportCSVSuccess(response.data));
      }, (error) => {
        dispatch(fetchWeightedPriceReportCSVFailure(error));
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(WeightedPriceContainer));
